import React from "react"
import { Link } from "gatsby"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// import Layout from "../components/layout"
// import Image from "../components/image"
// import SEO from "../components/seo"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import Header from "../components/header"
import Merlion from "./../images/2001-07-22_09.17.32.jpg"
import Raffles from "./../images/2001-08-18_02.02.53-1.jpg"
import Fountain from "./../images/2001-09-15_17.23.51.jpg"
import Footer from "../components/sitefooter"

import "./mystyles.scss"

console.log(Merlion)
console.log(Raffles)
console.log(Fountain)


const IndexPage = () => {
  return (
    <>
    <Header></Header>
     

      <section><div>
          <div class="container has-text-centered">
            <h1 class="title is-family-secondary">A database of longer-lasting art in public places in Singapore</h1>
            <Link to="/about">About the database &raquo;</Link>
          </div>
        </div>
      </section>
      <section class="section"><div class="container py-4">
          {/* <h2 class="title has-text-centered mb-6">Featuring...</h2> */}
          <div class="columns">
            <div class="column is-4">
              <div class="card">
                <div class="card-image">
                  <figure class="image is-4by3"><img src={Merlion} alt="the Merlion"/></figure></div>
                <div class="card-content">
                  <h4 class="title is-spaced is-4 is-family-secondary"><Link to={"/the-merlion"}>The Merlion</Link></h4>
                  <p class="subtitle is-6">Like it or not, the metonym for Singapore, a monster, formed of the head of a lion and a fishtail. Its origins likely lie in the Western art of heraldry.</p><Link to={"/the-merlion"}>Read more</Link>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="card">
                <div class="card-image">
                  <figure class="image is-4by3"><img src={Raffles} alt="Raffles (white)" /></figure></div>
                <div class="card-content">
                  <h4 class="title is-spaced is-4 is-family-secondary"><Link to={"/raffles-white"}>Raffles (white)</Link></h4>
                  <p class="subtitle is-6">In a prominent position on the Singapore River, this is a polymarble copy of the bronze original by Thomas Woolner. What motivated this act of copying? and this "whitening"?</p><Link to={"/raffles-white"}>Read more</Link>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="card">
                <div class="card-image">
                  <figure class="image is-4by3"><img src={Fountain} alt="Musical Fountain" /></figure></div>
                <div class="card-content">
                  <h4 class="title is-spaced is-4 is-family-secondary"><Link to={"/musical-fountain"}>Musical Fountain</Link></h4>
                  <p class="subtitle is-6">By pioneer sculptor Tan Teng Kee, this is one of the many public artworks removed from Singapore's public spaces without accountability, comment or fuss.</p>
                  <Link to={"/musical-fountain"}>Read more</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section"><div class="container">
          <div class="columns is-multiline">
            <div class="column is-6-tablet is-3-desktop">
              <div class="box">
                <div class="media">
                  <div class="media-left"></div>
                  <div class="media-content has-text-right">
                    <h3 class="title is-1 has-text-info">201</h3>
                  </div>
                </div>
                <h4 class="title is-family-secondary"><Link to="/artworks">Artworks</Link></h4>
                <progress class="progress is-warning" value="201" max="247"></progress></div>
            </div>
            <div class="column is-6-tablet is-3-desktop">
              <div class="box">
                <div class="media">
                  <div class="media-left"></div>
                  <div class="media-content has-text-right">
                    <h3 class="title is-1 has-text-danger">29</h3>
                  </div>
                </div>
                <h4 class="title is-family-secondary"><Link to="/artworksremoved">no longer in public spaces</Link></h4>
                <progress class="progress is-danger" value="29" max="201"></progress></div>
            </div>
            <div class="column is-6-tablet is-3-desktop">
              <div class="box">
                <div class="media">
                  <div class="media-left"></div>
                  <div class="media-content has-text-right">
                    <h3 class="title is-1 has-text-success">100</h3>
                  </div>
                </div>
                <h4 class="title is-family-secondary"><Link to="/artists">Artists</Link></h4>
                <progress class="progress is-success" value="87" max="100"></progress></div>
            </div>
            <div class="column is-6-tablet is-3-desktop">
              <div class="box">
                <div class="media">
                  <div class="media-left"></div>
                  <div class="media-content has-text-right">
                    <h3 class="title is-1 has-text-info">49</h3>
                  </div>
                </div>
                <h4 class="title is-family-secondary"><Link href="/todo">Works to add</Link></h4>
                <progress class="progress is-info" value="173" max="216"></progress>
                </div>
            </div>
          </div>
        </div>
      </section>
      


<Footer></Footer>

{/* <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>PublicArtSG</strong> by Peter Schoppert. The website content
      is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
    </p>
    <p>Most Recent Updates</p>
    <p style={{ fontSize: 12}}> November 25, 2020: Redid the homepage using Bulma and flexbox.</p>
<p style={{ fontSize: 12}}> November 1, 2020: Back to this after some time. Added three new sculptures, did a bit of tidying up.</p>
<p style={{ fontSize: 12}}> May 7, 2020: added lots of photos from 2001. Tidied up the "artworks" template. Pointed the form completion page to the correct URL</p>

  </div>
</footer> */}
    
    </>
  )
}
export default IndexPage